<template>
  <li class="v-item" :class="[`-${ photoMode }_photo`, `-bg_${ bgMode }`, `-ring_category_id_${ r.ring_category_id }`, photoMode == 'main' && this.$route.query.photoMode  ? `-transparent_bg_photo` : '' ]" :data-test="getProductBackgroundsInOrder(index)">
    <a class="v-anchor" :href="r.show_url" :title="$t('RingItem.urlTitle', { ringName: r.name })">
<!--
      <div class="v-itemBg" v-if="bgMode == 'random' || this.$route.query.photoMode == 'random'">
        <img :src="productBackgrounds[`${ getProductBackgroundsRandom() }`]">
      </div>
      <div class="v-itemBg" v-else-if="bgMode == 'in_order' || this.$route.query.photoMode == 'in_order'">
        <img :src="productBackgrounds[`${ getProductBackgroundsInOrder(index) }`]">
      </div>
      <div class="v-itemBg" v-else-if="this.$route.query.photoMode">
        <img v-if="photoMode == 'main' && (!['/set_rings'].includes($pathname)) && productBackgrounds[`${ this.$route.query.photoMode }`] " :src="productBackgrounds[`${ this.$route.query.photoMode }`]">
      </div>
      <div class="v-itemBg" v-else-if="bgMode != ''">
        <img :src="productBackgrounds[`${ bgMode }`]">
      </div>
-->
      <div class="v-itemImg">
        <picture>
          <!--
          <img v-if="(!['/set_rings'].includes($pathname)) && photoMode == 'main' && this.$route.query.photoMode" :src="r[`single_color_bg_photo`]" :alt="r.name">
          <img v-else :src="r[`${ photoMode }_photo`]" :alt="r.name">
          -->
          <img :src="getPhoto(r)" :alt="r.name">
        </picture>
      </div>
      <div class="v-inner">
        <h3 class="v-name">{{ r.name }}</h3>
        <p v-show="r.least_price" class="v-price">{{ r.least_price }}</p>
      </div>
      <div v-if="r.new_flag" class="v-new">NEW</div>
    </a>

    <template v-if="r.class_name === 'Ring'">
      <div
        v-show="!isFavoritedLoading"
        class="v-favorite"
        :title="[
          favoritedRings.includes(r.id) ? `${r.name}をお気に入りから削除する` : `${r.name}をお気に入りに登録する`
        ]"
        @click.stop="$emit('favoriteClick', $event, r)"
        :data-is-liked="[
          favoritedRings.includes(r.id) ? `true` : `false`
        ]"
      >
        <svg width="19.37" height="14.565" viewBox="-2 -2 40.74 31.13">
          <g>
            <g>
              <path d="M19.83,25c-2.1,2-3.67,3.48-3.67,3.48S5.93,18.94,2.55,14.76C-4.11,6.53,6.79-5.71,16.16,4.2c9.38-9.91,20.27,2.33,13.61,10.56-1.27,1.56-3.48,3.86-5.76,6.13" fill="none" stroke="#a1a1a1" stroke-miterlimit="10"/>
              <line x1="38.24" y1="23.45" x2="28.24" y2="23.45" fill="none" stroke="#a1a1a1" stroke-linecap="round" stroke-miterlimit="10"/>
              <line x1="33.24" y1="28.45" x2="33.24" y2="18.45" fill="none" stroke="#a1a1a1" stroke-linecap="round" stroke-miterlimit="10"/>
            </g>
          </g>
        </svg>
      </div>
    </template>

    <div class="v-quickview">
      <button type="button" class="v-quickViewButton" @click="$emit('quickViewClick', $event, r)" :title='`${r.name}をクイックビューで見る`'>
        <svg xmlns="http://www.w3.org/2000/svg" width="17" height="18.18" viewBox="0 0 34 36.36"><g id="ba6ea5d2-5661-412e-9a76-577e9e595864" data-name="レイヤー 2"><g id="a2951511-7bda-46e3-9aa1-f7116b6d26e6" data-name="レイヤー 1"><path d="M23.32,14.3H16.57l-1.93,2.43,5,3.56a.54.54,0,0,0,.3.1.57.57,0,0,0,.3-.1l5-3.56Z" fill="#4d4d4d"/><path d="M16,31.35h-.62a16.09,16.09,0,0,1-11.15-5A15.46,15.46,0,0,1,5.12,4.18,16.26,16.26,0,0,1,27.76,5a15.43,15.43,0,0,1-.86,22.15A16.08,16.08,0,0,1,16,31.35ZM16,.75a15.32,15.32,0,0,0-10.36,4,14.71,14.71,0,0,0-.81,21.09,15.48,15.48,0,0,0,21.55.8,14.7,14.7,0,0,0,.81-21.09A15.25,15.25,0,0,0,16.59.76Z" fill="#4d4d4d"/><path d="M33.62,36.36a.37.37,0,0,1-.29-.13l-5.59-6a.37.37,0,0,1,0-.53.39.39,0,0,1,.54,0l5.6,6a.37.37,0,0,1,0,.53A.39.39,0,0,1,33.62,36.36Z" fill="#4d4d4d"/><path d="M27.54,22.29a.4.4,0,0,1-.25-.09,11.41,11.41,0,0,0-2.85-1.74.36.36,0,0,1-.2-.49.39.39,0,0,1,.5-.2,12,12,0,0,1,3.05,1.86.36.36,0,0,1,0,.52A.37.37,0,0,1,27.54,22.29Z" fill="#4d4d4d"/><path d="M9.07,27.05l-.14,0a.38.38,0,0,1-.22-.49,11.92,11.92,0,0,1,6.75-6.85.39.39,0,0,1,.5.21.37.37,0,0,1-.21.49A11.14,11.14,0,0,0,9.43,26.8.4.4,0,0,1,9.07,27.05Z" fill="#4d4d4d"/></g></g></svg>
      </button>
    </div>
  </li>
</template>

<script>
export default {
  props: {
    r: {
      type: Object,
      required: true,
    },
    index: {
      type: Number,
      required: true,
    },
    favoritedRings: {
      type: Array,
      default: [],
    },
    isFavoritedLoading: {
      type: Boolean,
      default: true,
    },
    photoMode: {
      type: String,
      required: true,
    },
    bgMode: {
      type: String,
      required: true,
    },
    productBackgrounds: {
      type: Object,
      required: true,
    },
    productBackgroundsRandom: {
      type: Array,
      required: true,
    },
  },

  name: 'RingItem',

  // TODO: lazyload実装（packs/brand/shared/lazyload.jsの内容と同じことをしたい）
  mounted() {
  },
  methods: {
    getPhoto(r) {
      const mainPhotoCategoryIds = [6, 7, 8, 9];
      return mainPhotoCategoryIds.includes(r.ring_category_id) ? r.main_photo : r[`${this.photoMode}_photo`];
    },
    getProductBackgroundsRandom () {
      let array;
      if (this.$route.query.imgArray) {
        array = this.$route.query.imgArray.split('-');
      } else {
        array = this.productBackgroundsRandom;
      }

      const min = 0;
      const max = array.length-1;
      const randomNum = Math.floor(Math.random() * (max + 1 - min)) + min;
      return array[randomNum]
    },
    getProductBackgroundsInOrder (index) {
      let array;
      if (this.$route.query.imgArray) {
        array = this.$route.query.imgArray.split('-');
      } else {
        array = this.productBackgroundsRandom;
      }
      const length = array.length;
      const number = index % length
      return array[number]
    }
  },
}
</script>

<style lang="scss" scoped>
.v-item {
  border: 1px solid #e0e0e0;
  position: relative;
  border-radius: 2px;
  @media screen and (min-width: 900px) {
    border-radius: 4px;
  }
  &.-single_color_bg_photo {
    border-width: 0;
  }
  &.-ring_category_id_6 {
    border-width: 1px;
  }
}

.v-itemBg {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}

.v-itemImg {
  position: relative;
  height: 0;
  padding-top: 100%;

  img {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: top;
    transition: .5s transform;

    .v-anchor:hover &,
    .v-anchor:active & {
      transform: scale(1.3);
    }
  }
}

.v-anchor {
  text-decoration: none;
  overflow: hidden;
  height: 100%;
  display: flex;
  flex-direction: column;

  &:hover,
  &:active {
    opacity: 1;
  }
}

.v-inner {
  padding: 15px 38px 15px 15px;
  position: relative;
  background: #fff;
  transition: .3s background-color;
  flex-grow: 1;
  .v-item.-single_color_bg_photo & {
    padding-top: 0;
    background: #b9d2f0;
  }
  .v-item.-transparent_bg_photo & {
    padding-top: 0;
    background: transparent;
  }
  .v-item.-single_color_bg_photo.-ring_category_id_6 & {
    padding: 15px 38px 15px 15px;
    background: #fff;
  }
}

.v-name {
  font-size: 10px;
  margin: 0 0 5px;
  line-height: 1.2;
  @media screen and (min-width: 900px) {
    font-size: 14px;
  }
}

.v-price {
  font-size: 10px;
  font-family: var(--sans-serif-en);
  margin: 0;
  line-height: 1;
  @media screen and (min-width: 900px) {
    font-size: 12px;
  }
}

.v-new {
  position: absolute;
  top: 15px;
  left: 15px;
  font-family: var(--sans-serif-en);
  line-height: 1;
  font-size: 10px;
  @media screen and (min-width: 900px) {
    font-size: 14px;
  }
}

.v-favorite {
  cursor: pointer;
  position: absolute;
  top: 0;
  right: 0;
  padding: 10px;
  transition: .3s transform;

  &:hover {
    transform: scale(1.2);
  }

  svg {
    @media screen and (min-width: 900px) {
      width: 25px;
      height: 25px;
    }
  }

  path {
    transition: .3s stroke;
  }

  line {
    transition: .3s opacity;
  }

  &[data-is-liked="true"] {
    path {
      stroke: #da6f6b;
      stroke-width: 3px;
    }
    line {
      opacity: 0;
    }
  }
}

.v-quickview {
  position: absolute;
  right: 0;
  bottom: 0;
  padding: 10px;
  transition: .3s transform;

  svg {
    @media screen and (min-width: 900px) {
      width: 25px;
      height: 25px;
    }
  }

  &:hover {
    transform: scale(1.2);
  }
}

.v-quickViewButton {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  background: transparent;
  border: 0;
  color: inherit;
  font: inherit;
  padding: 0;
  outline: 0;
  letter-spacing: inherit;
  text-align: inherit;
}
</style>
